/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="docs-and-forms-kiosk.module.ts" />


module Meevo.Plugins.DocsAndFormsKiosk {
  import Appointment = Meevo.Model.Appointment;
  import IClientFormService = Meevo.Plugins.DocsAndForms.IClientFormService;
  import IGroupedByServiceForm = Meevo.Plugins.DocsAndForms.IGroupedByServiceForm;
  import IShowFormOptionRow = Meevo.Plugins.DocsAndForms.IShowFormOptionRow;
  declare var screenfull: any;

  interface ISubmittedFormRow {
    id: string;
    serviceId: string;
  }

  class DocsAndFormsKioskController {

    static $inject = [
      'meevo.ContextParams',
      '$sce',
      '$http',
      '$translate',
      '$scope',
      '$rootScope',
      'meevo.plugins.docsAndForms.DocsAndFormsApiService',
      'meevo.plugins.docsAndForms.DocsAndFormsService',
      'restServer',
      '$state',
      'meevo.components.common.KioskModeLogic',
    ];

    //#regionBindings
    public form: IShowFormOptionRow;
    public clientId: string;
    public appointmentId?: string;
    public iframeCallback?: Function;
    public deferCallback: ng.IDeferred<void>;
    public callbackState: string;

    //#endregionBindings

    public availableForms: IGroupedByServiceForm[];
    public url: string;
    public formSubmitted: boolean;

    private submittedFormRows: ISubmittedFormRow[];
    private groupedForms: IGroupedByServiceForm[];

    private iframeEventHandler;

    constructor(protected contextParams: Meevo.IContextParams,
                protected $sce: ng.ISCEService,
                protected $http: angular.IHttpService,
                protected $translate: angular.translate.ITranslateService,
                protected $scope: ng.IScope,
                protected $rootScope: ng.IRootScopeService,
                protected docsAndFormsApiService: Meevo.Plugins.DocsAndForms.DocsAndFormsApiService,
                protected docsAndFormsService: Meevo.Plugins.DocsAndForms.DocsAndFormsService,
                protected appointmentRestService: any,
                protected $state: ng.ui.IStateService,
                protected kioskModeLogic: Meevo.Components.Common.KioskModeLogic) {
      this.form = contextParams.params.form;
      this.clientId = contextParams.params.clientId;
      this.appointmentId = contextParams.params.appointmentId;
      this.iframeCallback = contextParams.params.iframeCallback;
      this.deferCallback = contextParams.params.deferCallback;
      this.callbackState = contextParams.params.callbackState || null;

      this.url = this.prepareUrl(this.form.formUrl);

      this.submittedFormRows = [{ id: this.form.formId, serviceId: this.form.serviceId }];

      this.groupedForms = [];

      this.loadForms();


      // Create IE + others compatible event handler
      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
      const eventer = window[eventMethod];
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

      // Listen to message from child window
      this.iframeEventHandler = (event: MessageEvent) => {
        if (event.data !== 'formSubmitted') return;

        this.formSubmitted = true;
        if (this.iframeCallback) {
          this.iframeCallback();
        }
        this.$scope.$apply();
        this.loadForms();
      }

      eventer(messageEvent, this.iframeEventHandler, false);
    }

    loadForms() {
      if (typeof this.appointmentId === 'string') {
        this.appointmentRestService
            .getAppointment(this.appointmentId, false, true)
            .then((res) => {
              const appointment: Appointment = res.data;
              const clientAppointmentServices = _(appointment.services).where({
                clientType: Meevo.Model.ClientTypeEnum.Client,
              });
              const request: any = {
                AppointmentServicesList: _(clientAppointmentServices).pluck('id'),
                TriggerEventEnum: Meevo.Model.DocsAndFormsTriggerEventEnum.Booked,
                isBuilt: true,
              };

              this.docsAndFormsApiService
                  .getAppointmentServiceFormList(request)
                  .then(this.onFormListLoaded.bind(this));
            });
      } else {
        this.docsAndFormsApiService.getClientFormList({
          clientId: this.clientId,
        }).then(this.onFormListLoaded.bind(this));
      }
    }

    onFormListLoaded(forms: IClientFormService[]) {
      for (const form of forms) {
        this.docsAndFormsService.populateServiceWithData(form);
      }
      this.groupedForms = this.docsAndFormsService.groupFormsByService(forms);
    }

    private prepareUrl(url: string) {
      return this.$sce.trustAsResourceUrl(`${url}&meevo=1`);
    }

    openForm(form: IClientFormService) {
      const newValue = form.displayName
      this.$rootScope.$broadcast('kioskHeaderUpdate', newValue);

      if (form.appointmentIsCheckedOut && form.hasAnswers) {
        // Fetched as a blob through the API, not opened by url: a private bucket emits
        // no fileUrl. The kiosk is authenticated -- it already loads its form list via
        // docsAndFormsApiService -- so the Bearer header the interceptor adds applies
        // here too.
        this.docsAndFormsService.openFormPdf(form.pdfUrlHistoryList[0]);

        return;
      }

      this.url = this.prepareUrl(form.formUrl);
      setTimeout(() => {
        this.submittedFormRows.push({ id: form.id, serviceId: form.appointmentServiceId });
        this.formSubmitted = false;

        this.$scope.$apply();

      }, 300);

    }

    close(response?: any): void {
      const eventMethod = window.addEventListener ? 'removeEventListener' : 'detachEvent';
      const eventer = window[eventMethod];
      const messageEvent = eventMethod === 'detachEvent' ? 'onmessage' : 'message';

      eventer(messageEvent, this.iframeEventHandler, false);

      // Clear kiosk logout cookie when exiting normally (not via page refresh)
      // This prevents the "login twice" issue when user logs back into Meevo after kiosk mode (bug 100214)
      this.kioskModeLogic.disableLogOutOnReload(this.$rootScope);

      if (screenfull.isEnabled && screenfull.isFullscreen) {
        console.log('screenfull.toggle() fill form modal');
        screenfull.toggle();
      }
      this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, this.callbackState, false);
      if (this.deferCallback) {
        this.deferCallback.resolve();
      }
    }
  }

  angular.module('meevo.plugins.docsAndFormsKiosk')
    .controller('meevo.plugins.docsAndFormsKiosk.DocsAndFormsKioskController', DocsAndFormsKioskController);
}
